<template>
  <div class="this-page">
    <template>
      <toolBar useSearch @search="searchOrder" @clear="clearSearch" from="user"/>
    </template>
    <template>
      <el-table :data="list" stripe style="width: 100%" size="small" :height="tableHeight"  border>
        <el-table-column prop="id" label="会员号" width="100" fixed>
        </el-table-column>
        <el-table-column prop="avatar" label="头像" width="61">
          <template slot-scope="scope">
            <el-avatar shape="square" :size="40" :src="scope.row.avatar"></el-avatar>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="昵称" min-width="200">
        </el-table-column>
        <el-table-column prop="mobile" label="绑定手机" min-width="120">
        </el-table-column>
        <el-table-column prop="balance" label="余额" min-width="120">
        </el-table-column>
        <el-table-column prop="VIP Mark" label="VIP Mark" width="120">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.vip > 0">VIP Lv {{scope.row.vip}}</el-tag>
            {{scope.row.vip > 0?'':'-'}}
          </template>
        </el-table-column>
        <!--
        <el-table-column prop="max_user" label="待入仓包裹" width="100">
        </el-table-column>
        <el-table-column prop="max_user" label="在仓包裹" width="100">
        </el-table-column>
        <el-table-column prop="max_user" label="申请打包中订单" width="180">
        </el-table-column>
        <el-table-column prop="max_user" label="待支付订单" width="180">
        </el-table-column>
        <el-table-column prop="max_user" label="待出库订单" width="180">
        </el-table-column>
        <el-table-column prop="max_user" label="在途订单" width="180">
        </el-table-column>
        <el-table-column prop="max_user" label="完成订单" width="180">
        </el-table-column>-->
        <el-table-column prop="created_at" label="注册时间" width="180">

        </el-table-column>
        <el-table-column prop="block_at" label="拉黑时间" width="180"/>
        <el-table-column prop="created_at" label="操作" width="210" fixed="right">
          <template slot-scope="scope">
            <el-button type="info" size="mini" plain round @click="detail(scope.row.id)">用户详情</el-button>
            <el-button type="info" size="mini" plain round @click="block(scope.row.id,scope.row.block)">解除黑名单</el-button>
          </template>
        </el-table-column>

      </el-table>
      <template>
        <el-pagination style="margin-top:20px" :current-page="page" background layout="prev, pager, next" :page-count="pageCount"
                       @current-change="pageChange">
        </el-pagination>
      </template>
    </template>

  </div>
</template>
<script>
import toolBar from '../../components/tool-bar/index.vue'
export default {
  components:{
    toolBar
  },
  data() {
    return {
      tableHeight: document.documentElement.clientHeight - 165 + 'px',
      load: {
        list: false
      },
      page: 1,
      searchValue:'',
      pageCount: 1,
      list: []
    }
  },
  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;

        that.tableHeight = window.fullHeight - 165 + 'px';  // 高

      })()
    };
    this.getList()
  },
  methods: {
    getList() {
      this.$fetch.post('User/getBlockUserList', {
        page: this.page,
        search:this.searchValue
      }, true).then(res => {
        this.load.list = true
        this.list = res.result
        this.pageCount = res.page
      })
    },
    pageChange(e) {
      this.page = e
      this.getList()
    },
    searchOrder(e){
      if(!e){
        this.$message({
          type: 'info',
          message: '当前没有搜索任何信息'
        });
        return false
      }
      this.searchValue = e
      this.page = 1
      this.getList()

    },
    clearSearch(){
      console.log('清空搜索')
      this.searchValue = ''
      this.page = 1
      this.getList()
    },
    charge(id){
      this.$prompt('请输入充值金额', '充值', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType:'number'
      }).then(({ value }) => {
        this.$fetch.post('User/charge', {
          id: id,
          value:value
        }, true).then(res => {
          this.$message({
            type: 'success',
            message: '充值成功'
          });
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
    },
    deduction(id){
      this.$prompt('请输入扣缴金额', '帐户扣缴', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType:'number'
      }).then(({ value }) => {
        this.$fetch.post('User/deduction', {
          id: id,
          value:value
        }, true).then(res => {
          this.$message({
            type: 'success',
            message: '扣缴成功'
          });
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
    },
    sendCoupon(id) {
      this.$prompt('请输入优惠券编码', '发放优惠券', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType:'number'
      }).then(({ value }) => {
        this.$fetch.post('User/sendCoupon', {
          id: id,
          value:value
        }, true).then(res => {
          this.$message({
            type: 'success',
            message: '发放成功'
          });

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
    },
    setVip(uid,vip){
      this.$prompt('请设置该客户VIP Level，0为非VIP', 'VIP Set', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType:'number',
        inputValue:vip
      }).then(({ value }) => {
        this.$fetch.post('User/setVip', {
          id: uid,
          value:value
        }, true).then(res => {
          this.$message({
            type: 'success',
            message: '设置成功'
          });
          this.getList()

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
    },
    detail(id){
      this.$router.push({path:'/user/detail',query:{id:id}})
    },
    block(uid,v){
      if(v == 0){
        this.$message({
          type: 'info',
          message: '该客户已不在黑名单内'
        });
        return false
      }
      this.$confirm('确定将该客户移出黑名单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$fetch.post('User/releaseBlock', {
          id: uid,
        }, true).then(res => {
          this.$message({
            type: 'success',
            message: '该客户已移出黑名单'
          });
          this.page = 1
          this.getList()

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
}
</script>

<style scoped>
.this-page {
  padding: 10px;
  background-color: #FFFFFF;
}
</style>
